export const initialFilterState = {
    brand: [],
    product: [],
    agg: [],
    dc: [],
};

export const initialSearchState = { brand: '', product: '', agg: '', dc: '' };
